import { Component } from 'react';
import Query from 'query-string';
import {actions} from 'forms/rrf';
import {connect} from 'react-redux';
import {welcomeAction} from '../../../actions/welcome';
import WelcomeForm from '../../common/invitation/welcome-form';

class Welcome extends Component {
  constructor(props) {
    super(props);
    this.token = Query.parse(window.location.search).invitation_token || '';
    this.model = 'deep.admin_welcome';
  }

  handleSubmit(payLoad) {
    const {dispatch} = this.props;
    dispatch(actions.submitFields(this.model, welcomeAction(payLoad, dispatch)));
  }

  render() {
    return (
      <div className="fluid">
        <WelcomeForm
          handleSubmit={this.handleSubmit.bind(this)}
          model={this.model}
          token={this.token}
          welcomeMessage="Welcome to the ignite administration portal"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  processed: state.welcome.processed,
});

export default connect(mapStateToProps)(Welcome);
